import request from './request'

const uniqueKey = 'zhiyitech-track-unique-id'
const infoKey = 'zhiyitech-track-common-info'

export default {
  login: (uniqueId) => {
    const oldId = sessionStorage.getItem(uniqueKey)
    if (oldId) {
      sessionStorage.removeItem(uniqueKey)
      sessionStorage.removeItem(infoKey)
    }
    sessionStorage.setItem(uniqueKey, uniqueId)
  },
  registerInfo: (obj) => {
    const oldInfo = sessionStorage.getItem(infoKey)
      ? JSON.parse(sessionStorage.getItem(infoKey))
      : {}
    const newObj = { ...oldInfo, ...obj }
    sessionStorage.setItem(infoKey, JSON.stringify(newObj))
  },
  logout: () => {
    sessionStorage.removeItem(uniqueKey)
    sessionStorage.removeItem(infoKey)
  },
  send: async ({ content, event, callback }) => {
    const distinct_id = sessionStorage.getItem(uniqueKey)
    const userInfo = sessionStorage.getItem(infoKey)
      ? JSON.parse(sessionStorage.getItem(infoKey))
      : {}
    const params = {
      content: {
        distinctId: distinct_id,
        properties: {
          ...userInfo,
          ...content,
          $url: location.href,
          $title: document.title
        },
        loginId: sessionStorage.getItem(uniqueKey),
        type: 'track',
        event,
      }
    }
    await request.post('/track/track-log', params)
    callback?.()
  }
}
